import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import IPOHub from "@/pages/IPOHub";
import DRHPVault from "@/pages/DRHPVault";
import News from "@/pages/News";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import NewsDetail from "@/pages/NewsDetail";
import Commodities from "@/pages/Commodities";
import Crypto from "@/pages/Crypto";
import RealEstate from "@/pages/RealEstate";
import Watchlist from "@/pages/Watchlist";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SearchResults from "@/pages/SearchResults";
import PolicyPage from "@/pages/PolicyPage";
import BuyMeCoffee from "@/pages/BuyMeCoffee";
import PushAlertsRunner from "@/components/PushAlertsRunner";
import OpeningBellRunner from "@/components/OpeningBellRunner";
import GAListener from "@/components/GAListener";
import AskAIWidget from "@/components/AskAIWidget";
import PageTransition from "@/components/PageTransition";
import IntroSplash from "@/components/IntroSplash";
import { useAuth } from "@/lib/auth";

function RequireAdmin({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-10 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col text-[#1A1A1A]" style={{ background: "#F7F4EE" }}>
        <GAListener />
        <IntroSplash />
        <PushAlertsRunner />
        <OpeningBellRunner />
        <AskAIWidget />
        <Header />
        <main className="flex-1">
          <PageTransition>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ipos" element={<IPOHub />} />
              <Route path="/drhp" element={<DRHPVault />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="/commodities" element={<Commodities />} />
              <Route path="/crypto" element={<Crypto />} />
              <Route path="/real-estate" element={<RealEstate />} />
              <Route path="/watchlist" element={<Watchlist />} />
              <Route path="/blogs" element={<Blogs />} />
              <Route path="/blogs/:slug" element={<BlogDetail />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/support" element={<BuyMeCoffee />} />
              <Route path="/about" element={<PolicyPage />} />
              <Route path="/privacy-policy" element={<PolicyPage />} />
              <Route path="/terms-of-use" element={<PolicyPage />} />
              <Route path="/editorial-policy" element={<PolicyPage />} />
              <Route path="/financial-disclaimer" element={<PolicyPage />} />
              <Route path="/market-data-sources" element={<PolicyPage />} />
              <Route path="/advertising-sponsorship" element={<PolicyPage />} />
              <Route path="/corrections-feedback" element={<PolicyPage />} />
              <Route path="/contact-us" element={<PolicyPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            </Routes>
          </PageTransition>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
